<app-state-view class="results-listing" [state]="state">
  <loading-state>
    <app-dots-spinner aria-label="Loading..."></app-dots-spinner>
  </loading-state>
  <empty-state>
    <div class="results-listing__placeholder">
      <mat-icon class="results-listing__placeholder-icon">info</mat-icon>
      <div class="results-listing__placeholder-message">Please enter a search query to perform a search.</div>
    </div>
  </empty-state>
  <error-state>
    <div class="results-listing__placeholder results-listing__placeholder--error">
      <mat-icon class="results-listing__placeholder-icon">warning</mat-icon>
      <div class="results-listing__placeholder-message">
        {{ errorMessage || 'An error occurred performing the search. Please try again later.' }}
      </div>
    </div>
  </error-state>
  <content-state>
    <div class="results-listing__container">
      <div class="results-listing__filter-bar">
        <button #airportPopoverAnchor="satPopoverAnchor" type="button" class="results-listing__filter"
                [satPopoverAnchorFor]="airportFiltersPopover" (click)="airportFiltersPopover.toggle()"
                [class.results-listing__filter--active]="airportPopoverAnchor.isPopoverOpen()">
          Airport Amenities
          <span *ngIf="numAirportFiltersSelected > 0" class="results-listing__filter-badge">
            {{ numAirportFiltersSelected }}
          </span>
          <mat-icon class="results-listing__filter-arrow">keyboard_arrow_down</mat-icon>
        </button>
        <div class="results-listing__price-toggle">
          <mat-slide-toggle class="results-listing__price-toggle" [(ngModel)]="showPrices"
                          (change)="onFuelPriceToggleChanged()">Show Fuel Prices</mat-slide-toggle>
          <div class="results-listing__price-learn_more_container"><a class="results-listing__learn_more_link" (click)="onClickFuelLearnMore()">Learn more</a></div>
        </div>
      </div>
      <div #listEl *ngIf="airports && airports.length > 0; else placeholder" class="results-listing__list">
        <app-airport-summary-card
          #airportEl *ngFor="let airport of airports"
          [airport]="airport" [active]="airport === activeAirport"
          [interactive]="true"
          (airportMouseEnter)="onAirportHover(airport, true)"
          (airportMouseLeave)="onAirportHover(airport, false)">
        </app-airport-summary-card>
      </div>
      <mat-paginator
        *ngIf="airports && airports.length > 0"
        class="results-listing__pagination"
        [pageIndex]="pageIndex"
        [length]="totalAirports"
        [pageSize]="pageSize"
        (page)="onPageChanged($event)">
      </mat-paginator>
    </div>
  </content-state>
</app-state-view>

<ng-template #placeholder>
  <div class="results-listing__placeholder">
    <mat-icon class="results-listing__placeholder-icon">info</mat-icon>
    <div class="results-listing__placeholder-message">
      No results found matching your search criteria. Try reducing the number of filters used in the search.
    </div>
  </div>
</ng-template>


<sat-popover #airportFiltersPopover horizontalAlign="start" verticalAlign="below" hasBackdrop>
  <div class="results-listing__popover">
    <app-airport-filter-list #airportFilters [query]="query" [compact]="true"
                             (publicUseChanged)="onPublicUseChanged()"
                             (filtersChange)="onFiltersChanged()"
                             (numSelectedChange)="onNumAirportFiltersSelectedChanged($event)">
    </app-airport-filter-list>
  </div>
</sat-popover>
